{
  "toast": {
    "automationCreated": "Automation créé",
    "actionAdded": "Action ajoutered",
    "boardCreated": "Board créé",
    "dependencyAdded": "Dependency ajoutered",
    "issueCreated": "Issue créé",
    "projectArchived": "Project archived",
    "projectCloned": "Project cloned",
    "projectCreated": "Project créé",
    "ifRegisteredALoginLinkWasSentTo": "If registered, a login link was sent à votre email",
    "signedIn": "Signed in",
    "portfolioCreated": "Portfolio créé",
    "resourceAllocated": "Resource allocated",
    "documentUploaded": "Document téléversé",
    "projectCreatedFromTemplate": "Project créé de template",
    "clientPortalUserCreated": "Client portal user créé",
    "sprintStarted": "Sprint started",
    "sprintCompleted": "Sprint terminé",
    "taskAddedToSprint": "Task ajoutered à sprint",
    "taskUpdated": "Task mis à jour",
    "taskCreated": "Task créé",
    "taskDeleted": "Task deleted",
    "timeLogged": "Time logged",
    "timesheetApproved": "Feuille de temps approuvée",
    "timesheetRejected": "Feuille de temps rejetée",
    "timesheetSubmitted": "Timesheet soumis",
    "projectCompleted": "Projet terminé",
    "reportExported": "{{reportType}} exporté",
    "financeInvoiceCreated": "Facture finance {{invoiceNumber}} créée ({{lineCount}} lignes)",
    "tasksSynced": "{{count}} tâches synchronisées vers le tableau"
  },
  "errors": {
    "failedToLoadAutomations": "Échec du chargement de automations",
    "failedToLoadActions": "Échec du chargement de actions",
    "createFailed": "Échec de la création",
    "updateFailed": "Échec de la mise à jour",
    "addActionFailed": "Échec de add action",
    "failedToLoadBoards": "Échec du chargement de boards",
    "failedToLoadBoard": "Échec du chargement de board",
    "createBoardFailed": "Échec de create board",
    "syncFailed": "Échec de la synchronisation",
    "moveFailed": "Échec du déplacement",
    "failedToLoadCalendar": "Échec du chargement de calendar",
    "enterBothTaskIds": "Saisissez both task IDs",
    "failedToLoadGantt": "Échec du chargement de gantt",
    "addDependencyFailed": "Échec de add dependency",
    "archiveFailed": "Échec de archive",
    "cloneFailed": "Échec du clonage",
    "requestFailed": "Échec de la requête",
    "verificationFailed": "Échec de la vérification",
    "budgetLoadFailed": "Échec de budget load",
    "reportsUnavailable": "Rapports unavailable",
    "exportFailed": "Échec de l'export",
    "failedToLoadResources": "Échec du chargement de resources",
    "allocateFailed": "Échec de allocate",
    "failedToLoadTemplates": "Échec du chargement de templates",
    "uploadFailed": "Échec du téléversement",
    "instantiateFailed": "Échec de instantiate",
    "portalInviteFailed": "Échec de portal invite",
    "backlogLoadFailed": "Échec de backlog load",
    "startSprintFailed": "Échec de start sprint",
    "completeSprintFailed": "Échec de complete sprint",
    "assignFailed": "Échec de l'assignation",
    "selectAProject": "Sélectionnez un project",
    "deleteFailed": "Échec de la suppression",
    "enterBillingDateRange": "Saisissez billing date range",
    "logTimeFailed": "Échec de log time",
    "billTimeFailedEnsureFinanceModuleAndBillable": "Bill time failed — ensure Finance module et billable hours exist",
    "submitFailed": "Échec de la soumission",
    "timesheetApprovalFailed": "Échec de l'approbation de la feuille de temps",
    "timesheetRejectionFailed": "Échec du rejet de la feuille de temps",
    "projectCompletionFailed": "Échec de la finalisation du projet",
    "analyticsUnavailable": "Analytique indisponible",
    "failedToLoadIssues": "Échec du chargement de issues",
    "failedToLoadProjects": "Échec du chargement de projects",
    "failedToLoadPortfolios": "Échec du chargement de portfolios",
    "failedToLoadSprints": "Échec du chargement de sprints",
    "failedToLoadTasks": "Échec du chargement de tasks",
    "failedToLoadTimesheets": "Échec du chargement de timesheets"
  },
  "pages": {
    "automation": "Automatisation",
    "createAutomation": "Create automation",
    "addWorkflowAction": "Add flux de travail action",
    "workflowTriggersAndActionsForTasks": "Flux de travail triggers et actions pour tasks et sprints",
    "boards": "Tableaux",
    "createBoard": "Create board",
    "kanbanBoardsWithDragAndDrop": "Kanban boards avec drag-and-drop, WIP limits, et flux de travail columns",
    "calendar": "Calendrier",
    "milestonesAndTaskDueDates": "Milestones et task due dates",
    "projectsDashboard": "Projects Tableau de bord",
    "deliveryDetails": "Delivery details",
    "tasks": "Tasks",
    "issues": "Tickets",
    "activeSprints": "Active Sprints",
    "deliveryHealthAcrossProjectsTasksIssues": "Delivery health across projects, tasks, issues, et sprints in votre scope",
    "gantt": "Gantt",
    "timelineViewWithDependenciesAndCritical": "Timeline afficher avec dependencies et critical path",
    "createIssue": "Create issue",
    "bugsAndDeskTicketEscalationsAuto": "Bugs et Desk ticket escalations (auto-linked de Desk)",
    "projects": "Projets",
    "createProject": "Create project",
    "portfolioOfClientAndInternalDelivery": "Portfolio of client et internal delivery projects",
    "projectClientPortal": "Project client portal",
    "verifyLogin": "Verify login",
    "viewYourProjectStatusTasksDocuments": "View votre project status, tasks, documents, et factures",
    "completeClientPortalSignIn": "Complete client portal sign-in",
    "pmoPortfolio": "PMO & Portfolio",
    "createPortfolio": "Create portfolio",
    "executiveDashboardPortfoliosAndProjectBudget": "Executive tableau de bord, portfolios, et project budget health",
    "projectReports": "Project Rapports",
    "deliveryAnalyticsAndExportableReports": "Delivery analytics et exportable rapports",
    "resourcePlanning": "Resource planning",
    "teamAllocationAndCapacityByProject": "Team allocation et capacity by project",
    "projectSetup": "Project Configuration",
    "templatesClientPortalAndConfiguration": "Templates, client portal, et configuration",
    "pdfWordExcelOrImages": "PDF, Word, Excel, ou images",
    "sprints": "Sprints",
    "startSprint": "Start sprint",
    "backlogSprintPlanningExecutionAndVelocity": "Backlog, sprint planning, execution, et velocity",
    "createTask": "Créer une tâche",
    "editTask": "Modifier la tâche",
    "edit": "Modifier",
    "delete": "Supprimer",
    "hierarchicalTasksWithCreateEditAnd": "Hierarchical tasks avec create, edit, et delete",
    "timesheets": "Feuilles de temps",
    "logTime": "Log time",
    "submitTimesheet": "Submit timesheet",
    "logTimeSubmitWeeklyTimesheetsAnd": "Log time, submit weekly timesheets, et approve hours",
    "workload": "Charge de travail",
    "activeProjects": "Active projects",
    "taskCompletion": "Task completion",
    "loggedHoursMonth": "Logged hours (month)",
    "sprintVelocity": "Sprint velocity",
    "resourceUtilizationAndCapacityPlanning": "Resource utilization et capacity planning",
    "billApprovedTimeToFinance": "Facturer le temps approuvé à Finance",
    "createsFinanceInvoiceFromBillableTimeEntries": "Crée une facture Finance à partir des temps facturables dans la plage de dates (`ProjectTimeBillingService`).",
    "roleDashboards": "Tableaux de bord par rôle",
    "openIssues": "Tickets ouverts",
    "billingQueue": "File de facturation",
    "budgetUtilization": "Utilisation du budget",
    "seePortfolio": "Voir le portefeuille",
    "profitability": "Rentabilité",
    "allocationConflicts": "Conflits d'allocation",
    "capacityRecords": "Enregistrements de capacité",
    "visibleDocuments": "Documents visibles",
    "milestones": "Jalons",
    "portal": "Portail",
    "project360": "Projet 360",
    "loadingProject": "Chargement du projet",
    "workBreakdownStructure": "Structure de découpage du travail",
    "recentTasks": "Tâches récentes",
    "milestonesAndDeliverables": "Jalons et livrables",
    "recentActivity": "Activité récente",
    "documents": "Documents",
    "sourceAndPlanningTraceability": "Traçabilité des sources et de la planification"
  },
  "labels": {
    "ruleName": "Nom de la règle",
    "triggerEvent": "Trigger event",
    "actionType": "Action type",
    "boardCode": "Board code",
    "boardName": "Board name",
    "selectProject": "Select project",
    "taskId": "Task ID",
    "dependsOnTaskId": "Depends on task ID",
    "dependencyType": "Type de dépendance",
    "lagDays": "Jours de décalage",
    "dependsOn": "Dépend de",
    "baseline": "Référence",
    "forecast": "Prévision",
    "slackDays": "Marge : {{count}} jours",
    "criticalPath": "Chemin critique",
    "title": "Titre",
    "description": "Descriptif",
    "projectCode": "Project code",
    "projectName": "Project name",
    "projectType": "Type de projet",
    "budget": "Budget",
    "lifecycle": "Cycle de vie",
    "expectedCost": "Coût attendu",
    "currency": "Devise",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "timezone": "Fuseau horaire",
    "warrantyEndDate": "Date de fin de garantie",
    "tagsJson": "Tags JSON",
    "creationSource": "Source de création",
    "source": "Origine",
    "sourceId": "ID source",
    "organizationId": "ID de l'organisation",
    "email": "Email",
    "token": "Jeton",
    "code": "Code",
    "name": "Nom",
    "allocation": "Allocation %",
    "clientEmail": "Client email",
    "uploadDocument": "Upload document",
    "sprintCode": "Sprint code",
    "sprintName": "Sprint name",
    "goal": "Goal",
    "backlogProject": "Backlog project",
    "productBacklogWithCount": "Backlog produit ({{count}})",
    "taskNumber": "Tâche n° {{id}}",
    "allProjects": "All projects",
    "project": "Project",
    "velocity": "Vélocité",
    "date": "Date",
    "hours": "Heures",
    "employee": "Employé",
    "weekStart": "Début de semaine",
    "weekEnd": "Fin de semaine",
    "status": "Statut",
    "actions": "Opérations",
    "task": "Tâche",
    "type": "Catégorie",
    "assignee": "Assigné",
    "due": "Échéance",
    "estimatedHours": "Heures estimées",
    "actualHours": "Heures réelles",
    "expectedRevenue": "Revenu attendu",
    "actualCost": "Coût réel",
    "milestone": "Jalon",
    "target": "Cible",
    "deliverable": "Livrable",
    "documentNumber": "Document n° {{id}}",
    "folder": "Dossier",
    "category": "Catégorie",
    "version": "Version",
    "customerVisible": "Visible par le client",
    "estimatedShort": "Est.",
    "actualShort": "Réel",
    "customerId": "ID client",
    "opportunityDealId": "ID opportunité/deal",
    "quotationId": "ID devis",
    "salesOrderId": "ID commande client",
    "managerId": "ID responsable",
    "ownerId": "ID propriétaire",
    "departmentId": "ID département",
    "businessUnitId": "ID unité commerciale",
    "projectManagerId": "ID chef de projet",
    "ownerEmployeeId": "ID employé propriétaire",
    "start": "Début",
    "end": "Fin",
    "warrantyEnd": "Fin de garantie"
  },
  "formActions": {
    "submitWeek": "Soumettre la semaine"
  },
  "listActions": {
    "newProject": "Nouveau projet",
    "view": "Voir",
    "archive": "Archiver",
    "clone": "Cloner",
    "cancel": "Annuler",
    "create": "Créer",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "addDependency": "Ajouter une dépendance",
    "newBoard": "Nouveau tableau",
    "syncTasks": "Synchroniser les tâches",
    "newPortfolio": "Nouveau portefeuille",
    "newTask": "Nouvelle tâche",
    "newIssue": "Nouveau ticket",
    "newRule": "Nouvelle règle",
    "logTime": "Saisir le temps",
    "startSprint": "Démarrer le sprint",
    "start": "Démarrer",
    "useTemplate": "Utiliser",
    "grantPortalAccess": "Accorder l'accès au portail",
    "sendMagicLink": "Envoyer le lien magique",
    "approve": "Approuver",
    "reject": "Rejeter",
    "billToFinance": "Facturer à Finance",
    "back": "Retour",
    "complete": "Terminer"
  },
  "dependencyTypes": {
    "finishToStart": "Fin à début",
    "startToStart": "Début à début",
    "finishToFinish": "Fin à fin",
    "startToFinish": "Début à fin"
  },
  "sourceModes": {
    "manual": "Manuel",
    "deal": "Opportunité/deal CRM",
    "quote": "Devis commercial"
  },
  "dialogs": {
    "deleteTaskTitle": "Supprimer la tâche",
    "deleteTaskMessage": "Cette tâche sera supprimée définitivement."
  },
  "status": {
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "tracked": "Suivi",
    "guarded": "Protégé",
    "enabled": "Activé",
    "restricted": "Restreint",
    "yes": "Oui",
    "no": "Non"
  },
  "personas": {
    "executive": "Direction",
    "pm": "Chef de projet",
    "team": "Équipe",
    "resource": "Ressource",
    "finance": "Finances",
    "customer": "Client"
  },
  "empty": {
    "noRecentProjectActivity": "Aucune activité récente du projet.",
    "noProjectDocumentsYet": "Aucun document de projet pour le moment.",
    "noWbsTasksYet": "Aucune tâche WBS pour le moment.",
    "noTasksWithDates": "Aucune tâche avec dates pour ce projet."
  }
}
